'use client'

import React from 'react'
import { PartnershipMock } from '@components/AboutUs/AboutUsMock'
import { PartnerType } from '@interfaces/aboutUs'
import { useElementVisible } from '@hooks/useElementVisible'
import styles from './Partnerships.module.scss'
import { MediaContainer, TopHeader } from './PartnerCards'

const Partner = ({ item, idx }: PartnerType) => {
  const PartnerSection = useElementVisible({ threshold: 0.2 })

  return (
    <div
      ref={PartnerSection.ref}
      className={`${styles.card} ${idx === 0 ? styles.topHeader : ''} ${
        PartnerSection.isVisible && idx !== 0 ? styles.popOutAnimation : ''
      }`}
      key={item.id}
      style={{ gridArea: `${item.id}` }}>
      {item.content ? (
        <TopHeader capital={item.content.capital} heading={item.content.heading} />
      ) : item.image ? (
        <MediaContainer src={item.image} centeredMedia={!item.fullImage} />
      ) : null}
    </div>
  )
}

const Partnerships: React.FC = () => (
  <div className={styles.partnershipsContainer}>
    <div className={styles.grid}>
      {PartnershipMock?.partnerships?.map((item, idx) => <Partner item={item} idx={idx} key={idx} />)}
    </div>
  </div>
)

export default Partnerships
